import { MultipleItemResponse, SingleItemResponse, fetchContent } from './fetchContent'

type Args = {
  language: string
  id: string
}

export const getPrivilegeItem = async <Model>({
  language,
  id,
}: Args): Promise<SingleItemResponse<Model> | null> => {
  const response: MultipleItemResponse<any> = await fetchContent({
    path: '',
    preview: true,
    params: {
      language,
      limit: 1,
      'system.id': id,
      'system.type[in]': ['privilege_item'],
    },
  })

  if (response.pagination.count === 0) {
    return null
  }

  return {
    item: response.items[0],
    modular_content: response.modular_content,
  }
}
